import React, { FC, useEffect, useState } from 'react';
import ReactTooltip from 'react-tooltip';
import { TooltipProps } from '.';
import { v4 as uuid } from 'uuid';

export const TooltipTemplate: FC<TooltipProps> = ({
    className,
    handle,
    children,
    event,
    eventOff,
    page,
    ...other
}): JSX.Element => {
    const [id, setId] = useState('');
    useEffect(() => {
        setId(uuid());
    }, []);
    return id ? (
        <div className={className}>
            <div data-for={id} data-tip data-event={event} data-event-off={eventOff}>
                {handle}
            </div>
            <ReactTooltip {...other} id={id} className={page !== 'basket' ? 'tooltip-box' : 'tooltip-box-basket'}>
                {children}
            </ReactTooltip>
        </div>
    ) : null;
};
